import ContentsService from "../services/contents.service";

export const contents = {
  namespaced: true,
  actions: {
    get({ }, filters = {}) {
      return ContentsService.get(filters)
    },
    getAllContents({ }, params = {}) {
      return ContentsService.getAllContents(params)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    },
    getContentsByType({ }, { type, params = {} }) {
      return ContentsService.getContentsByType(type, params)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    },
    getCategories({ }, params = {}) {
       return ContentsService.getCategories(params)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    },
    getSubcategories({ }, categoryId) {
      return ContentsService.getSubcategories(categoryId)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    },
    getContentByLinkName({ }, linkName) {
      return ContentsService.getContentByLinkName(linkName)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    },
    getTags({ }, params = {}) {
      return ContentsService.getTags(params)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    }
  },
  mutations: {},
  getters: {},
};
